<div class="payment-form-page">
  <button type="button" class="back-link" (click)="goBack()">
    <i class="bi bi-arrow-left" aria-hidden="true"></i>
    Torna a tutti i pagamenti
  </button>

  <form class="payment-card" [formGroup]="form" (ngSubmit)="submit()" novalidate>
    <header class="card-header">
      <div class="title-row">
        <h1>Iscrizione e Quota</h1>
        <span class="card-tag">Sostegno Annuale</span>
      </div>
      <p class="hint">
        Inserisci i tuoi dati e l'importo della quota associativa per procedere al pagamento.
      </p>
      <p class="hint">
        L'importo da pagare è indicato nella lettera ricevuta dalla Misericordia.
      </p>
    </header>

    <div class="field-row">
      <div class="field">
        <label class="field-label" for="importo">
          Importo (€) <span class="required" aria-hidden="true">*</span>
        </label>
        <span
          class="amount-field"
          [class.error]="form.controls.importo.touched && form.controls.importo.invalid">
          <span class="amount-prefix" aria-hidden="true">€</span>
          <input
            id="importo"
            type="text"
            formControlName="importo"
            inputmode="decimal"
            autocomplete="off"
            placeholder="15,00"
            [attr.aria-invalid]="form.controls.importo.touched && form.controls.importo.invalid"
            (input)="onImportoInput($event)"
            (blur)="onImportoBlur()">
        </span>
        <p class="error" [class.is-visible]="form.controls.importo.touched && form.controls.importo.invalid">
          @if (form.controls.importo.errors?.['required']) {
            Inserisci l'importo.
          } @else if (form.controls.importo.errors?.['min']) {
            L'importo minimo è 5 €.
          } @else {
            Inserisci un importo valido in euro, per esempio 10 o 10,50.
          }
        </p>
      </div>
    </div>

    <div class="field-row">
      <div class="field">
        <label class="field-label" for="nome">
          Nome <span class="required" aria-hidden="true">*</span>
        </label>
        <input
          id="nome"
          type="text"
          formControlName="nome"
          autocomplete="given-name"
          placeholder="Mario"
          [class.error]="form.controls.nome.touched && form.controls.nome.invalid"
          [attr.aria-invalid]="form.controls.nome.touched && form.controls.nome.invalid">
        <p class="error" [class.is-visible]="form.controls.nome.touched && form.controls.nome.invalid">
          Inserisci il nome.
        </p>
      </div>

      <div class="field">
        <label class="field-label" for="cognome">
          Cognome <span class="required" aria-hidden="true">*</span>
        </label>
        <input
          id="cognome"
          type="text"
          formControlName="cognome"
          autocomplete="family-name"
          placeholder="Rossi"
          [class.error]="form.controls.cognome.touched && form.controls.cognome.invalid"
          [attr.aria-invalid]="form.controls.cognome.touched && form.controls.cognome.invalid">
        <p class="error" [class.is-visible]="form.controls.cognome.touched && form.controls.cognome.invalid">
          Inserisci il cognome.
        </p>
      </div>
    </div>

    <div class="field">
      <label class="field-label" for="codiceFiscale">
        Codice Fiscale <span class="required" aria-hidden="true">*</span>
      </label>
      <input
        id="codiceFiscale"
        type="text"
        formControlName="codiceFiscale"
        autocomplete="off"
        spellcheck="false"
        maxlength="16"
        placeholder="RSSMRA80A01D612X"
        class="uppercase"
        [class.error]="form.controls.codiceFiscale.touched && form.controls.codiceFiscale.invalid"
        [attr.aria-invalid]="form.controls.codiceFiscale.touched && form.controls.codiceFiscale.invalid"
        (blur)="onCodiceFiscaleBlur()">
      <p class="error" [class.is-visible]="form.controls.codiceFiscale.touched && form.controls.codiceFiscale.invalid">
        @if (form.controls.codiceFiscale.errors?.['required']) {
          Inserisci il codice fiscale.
        } @else {
          Inserisci un codice fiscale valido di 16 caratteri.
        }
      </p>
    </div>

    <div class="pay-area">
      <button type="submit" class="pay">
        Procedi al Pagamento
        <i class="bi bi-arrow-right" aria-hidden="true"></i>
      </button>
      <p class="form-error" [class.is-visible]="showFormError()" role="alert">
        Controlla i campi evidenziati e riprova.
      </p>
    </div>
  </form>

  @if (summary(); as receipt) {
    <app-payment-summary
      [summary]="receipt"
      (closed)="closeSummary()"
      (pay)="pay()" />
  }
</div>
